import { CustomerPaymentHistory } from "../../../model/payments/payments";
import styles from "./AdminCustomerDetailsPage.module.scss";
import { FulfilledLoans } from "../../../model/orders/orders";
import OrderDetailSideDialog from "../solar-provider/solar-provider-details/OrderDetailsSideDailog";
import { useState } from "react";

interface FulfilledLoansProps {
	data: FulfilledLoans[];
}
const FullfilledLoans: React.FC<FulfilledLoansProps> = ({ data }) => {
	const [selectedOrder, setSelectedOrder] = useState("");
	return (
		<>
			{selectedOrder && <OrderDetailSideDialog orderId={selectedOrder} handleCloseDialog={() => setSelectedOrder("")} />}
			<div>
				<div className={styles.tableContainer}>
					<table className="standardTable">
						<thead>
							<tr>
								<th>Deposit</th>
								<th>Capital</th>
								<th>Interest</th>
								<th>Duration</th>
								<th>Loan Status</th>
								<th>View Details</th>
							</tr>
						</thead>
						<tbody>
							{data?.map(order => {
								return (
									<tr key={order?.orderId}>
										<td>₦ {order?.deposit?.toLocaleString()}</td>
										<td>₦ {order?.capital?.toLocaleString()}</td>
										<td>{order?.interest?.toLocaleString()}</td>
										<td>{order?.durationInMonths} (Months)</td>
										<td>{order?.status}</td>
										<td>
											<div onClick={() => setSelectedOrder(order?.orderId)} className={styles.viewDetails}>
												View Details
											</div>
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</div>
			</div>
		</>
	);
};

export default FullfilledLoans;
